
import React from 'react';


const Home = () => {
  return (
    <div className='page-basics'>
      <h2>ABOUT ME</h2>
      <p style={{ textAlign: 'left' }}>
        Heya, I'm Ann – Wife, Animal Lover, Nature Lover, Story Teller, Writer, Explorer and Leader. Lover of great food and wine, travel, and adventure.
        I have 20+ years of Executive Leadership and Operational Management Experience.
        <h3>MY MAGIC 🎉</h3>
        I get things done! Organising chaos. Organising EVERYTHING. Problem-solving. Improving organisational processes. Developing relationships that last. Versatile and highly adaptive. Strong intellectual curiosity.

        <h3>MY MISSION 💡</h3>
        Putting processes in place to ensure smooth, productive, and profitable businesses. Developing growth-minded cultures, inspiring people to grow and reach heights they never thought possible. It's all about building relationships!

        <h3>MY MOTTO 🤸‍♀️</h3>
        Learning and attaining knowledge is imperative for growth, both personal and professional. A literary character said it even better:

        "The more that you read, the more things you will know. The more that you learn, the more places you'll go" – Dr Seuss.
        <br /><br />
        Oh – and a cup of tea fixes almost everything……….<br />
        <br />
        When it's time to relax, my passions❤️are reading, nature, food, and travel. I've been lucky enough to spend time in many fascinating countries, immersing myself in unique landscapes and communities. Travel is not only fun, but a learning opportunity – not all learning happens in books! Fascinated by fabulous food, love to dabble in the kitchen, and music is always close by. I am a voracious reader.
      </p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

    </div>
  );
};

export default Home;